import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SharedService {
  // åæ¢tool åæéæ©å·¥å·
  private _changeToSelectTool: Subject<any>;

  constructor() {
    this._changeToSelectTool = new Subject<any>();
  }

  getChangeToSelectTool$(): Observable<any> {
    return this._changeToSelectTool.asObservable();
  }
  sendChangeToSelectTool() {
    this._changeToSelectTool.next();
  }
}
